import React from "react";

import { MESSAGE } from "constants/Message";

import {
  buttonModalConfirmDisable,
  buttonModalConfirmClass,
  buttonModalCancelDisable,
  buttonModalCancelClass,
} from "helpers/StyleClass.js";

class ModalFooter extends React.Component {
  render() {
    const {
      msg,
      disableCancel = false,
      disableConfirm = false,
      isLoading = false,
      cancelText = "Cancel",
      confirmText = "Proceed",
      closeText = "Close",
      redo = true,
      switchToCloseOnSuccess = true,
    } = this.props;

    let msgClass = "bg-green-200 text-green-700";
    if (msg && msg.length > 1) {
      if (msg[1] === MESSAGE.ERROR) {
        msgClass = "bg-red-200 text-red-700";
      } else if (msg[1] === MESSAGE.WARNING) {
        msgClass = "bg-orange-200 text-orange-600";
      }
    }

    return (
      <>
        {msg && msg.length > 0 && msg[0] !== "" && (
          <div
            className={`rounded mb-4 overflow-y-auto px-4 py-2 text-lg font-semibold ${msgClass}`}
            style={{ maxHeight: "100px" }}
          >
            {msg[0]}
          </div>
        )}
        <div className="relative flex h-10 w-full items-end justify-end gap-2">
          {isLoading ? (
            <div className="absolute bottom-0 right-0">
              <div className="loader"></div>
            </div>
          ) : (
            <>
              {msg &&
              ((switchToCloseOnSuccess && msg[1] === MESSAGE.SUCCESS) ||
                (!redo && msg[1] === MESSAGE.ERROR)) ? (
                <>
                  <button
                    type="button"
                    className={buttonModalConfirmClass}
                    onClick={
                      this.props.onClose
                        ? this.props.onClose
                        : this.props.onCancel
                    }
                  >
                    {closeText}
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className={
                      disableCancel
                        ? buttonModalCancelDisable
                        : buttonModalCancelClass
                    }
                    disabled={disableCancel}
                    onClick={this.props.onCancel}
                  >
                    {cancelText}
                  </button>

                  {this.props.children}

                  <button
                    type="button"
                    className={
                      disableConfirm
                        ? buttonModalConfirmDisable
                        : buttonModalConfirmClass
                    }
                    disabled={disableConfirm}
                    onClick={this.props.onConfirm}
                  >
                    {confirmText}
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default ModalFooter;
